
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FDialog'
})
class FDialog extends Vue {
  @Prop() readonly eventName!: string

  private showDialog = false

  private get hasTriggerIcon(): boolean {
    return !!this.$slots.triggerIcon
  }

  private get hasTriggerText(): boolean {
    return !!this.$slots.triggerText
  }

  private mounted(): void {
    document.addEventListener(this.eventName, () => {
      this.showDialog = false
    })
  }

  public toggleDialog(): void {
    this.showDialog = true
  }
}

export default FDialog
